'use client'

import { useEffect } from 'react'

// This needs to be a client component that is imported in the IFrameLayout
function IFrameResizer() {
  useEffect(() => {
    void import('@iframe-resizer/child')
  }, [])
  return null
}

export default IFrameResizer
